<div class="zag-inline-assignments">
  @if (loading()) {
  <div class="zag-inline-assignments__loading" role="status">
    <div class="zag-inline-assignments__skeleton-row"></div>
    <div class="zag-inline-assignments__skeleton-row"></div>
    <div class="zag-inline-assignments__skeleton-row"></div>
  </div>
  } @else if (items().length === 0) {
  <p class="zag-inline-assignments__empty">{{ emptyMessage() }}</p>
  } @else { @for (item of items(); track trackBy()(item, $index); let i = $index) {
  <div class="zag-inline-assignments__row">
    <div class="zag-inline-assignments__content">
      <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item, index: i }" />
    </div>
    <div class="zag-inline-assignments__actions">
      @if (showCopy()) {
      <button
        zagButton="outlined"
        type="button"
        class="zag-inline-assignments__copy"
        (click)="copyItem.emit(i)"
        [attr.aria-label]="copyLabel()"
        [disabled]="disabled()"
      >
        <span zagIcon="content-copy"></span>
      </button>
      }
      <button
        zagButton="outlined"
        type="button"
        class="zag-inline-assignments__remove"
        (click)="remove.emit(i)"
        [attr.aria-label]="removeLabel()"
        [disabled]="disabled()"
      >
        <span zagIcon="delete"></span>
      </button>
    </div>
  </div>
  } }

  <div class="zag-inline-assignments__add-form" [class.zag-inline-assignments__add-form--disabled]="disabled() || loading()">
    <ng-content select="[slot=add-form]" />
  </div>

  @if (!hasAddForm()) {
  <button type="button" class="zag-inline-assignments__add" (click)="add.emit()" [disabled]="disabled() || loading()">
    <span zagIcon="add"></span>
    <span>{{ addLabel() }}</span>
  </button>
  }
</div>
